import { Component } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: []
})
export class AppHeaderComponent {

  UtenteLogout() {
    localStorage.setItem("username", '[]');
    localStorage.setItem("usernameUtente", '[]');
    localStorage.removeItem("username");
    localStorage.removeItem("usernameUtente");
  }

}
